import { inject, Injectable, InjectionToken } from '@angular/core';
import { map, Observable, of, switchMap } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { BackendFeatureService } from '../backend-feature.service';

export interface ActiveBrandingGroupResolver {
  /** The user group whose branding should apply to the current session, or null for none. */
  getActiveGroup(): Observable<string | null>;
}

export const ACTIVE_BRANDING_GROUP_RESOLVER = new InjectionToken<ActiveBrandingGroupResolver>(
  'ACTIVE_BRANDING_GROUP_RESOLVER'
);

/** Standard default: the current user's first active group (alphabetical/insertion order of activeGroups). */
@Injectable({ providedIn: 'root' })
export class DefaultActiveBrandingGroupResolver implements ActiveBrandingGroupResolver {
  protected authService = inject(AuthService);
  protected featureService = inject(BackendFeatureService);

  getActiveGroup(): Observable<string | null> {
    return this.featureService.isActivated('customer-branding').pipe(
      switchMap(active =>
        active
          ? this.authService.getCurrentUser().pipe(
              map(user => {
                const groups = (user as any)?.activeGroups as { [k: string]: boolean } | undefined;
                if (!groups) {
                  return null;
                }
                const activeGroup = Object.keys(groups).find(k => groups[k] === true);
                return activeGroup ?? null;
              })
            )
          : of(null)
      )
    );
  }
}
